package com.dotdrives.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.*
import kotlin.time.Instant

/** A server-confirmed staff flag and whether this Auth session can enter the console. */
data class StaffEntry(val role:String,val authorized:Boolean)

@Serializable
data class AdminSupportSession(
    val id: String,
    @SerialName("org_id") val orgId: String? = null,
    @SerialName("org_name") val orgName: String? = null,
    val mode: String,
    @SerialName("expires_at") val expiresAt: Instant,
    val email: String? = null,
) {
    fun expired(now: Instant) = now >= expiresAt
}

@Serializable
data class AdminIdentity(
    @SerialName("user_id") val userId: String,
    val email: String,
    val role: String,
    @SerialName("expires_at") val expiresAt: Instant,
    val session: AdminSupportSession? = null,
) {
    val isSuperAdmin get() = role == "super_admin"
    fun expired(now: Instant) = now >= expiresAt
}

@Serializable
data class OrgAccessState(
    val paused: Boolean = false,
    @SerialName("support_mode") val supportMode: String? = null,
    val session: AdminSupportSession? = null,
) {
    val readOnly get() = paused || supportMode == "read"
}

/** UX validation only. Server staff, scope and confirmation checks remain authoritative. */
fun adminConfirmationValid(action: String, typed: String, orgName: String): Boolean = when(action) {
    "suspend" -> typed == "suspend"
    "delete.schedule" -> typed == orgName && orgName.isNotBlank()
    else -> true
}

fun adminRequiresSuper(action: String): Boolean = action !in setOf("note", "session.end", "support.reset", "support.revoke")

fun adminRouteSection(hash: String): String = hash.substringBefore('?').removePrefix("#/admin").trim('/').substringBefore('/').ifEmpty { "attention" }
